import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a032597&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1a032597&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a032597",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a032597')) {
      api.createRecord('1a032597', component.options)
    } else {
      api.reload('1a032597', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a032597&scoped=true", function () {
      api.rerender('1a032597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/technology/ContractComparison/index.vue"
export default component.exports